import { HttpClientEngineCapability33x11oaa7ywe5 as HttpClientEngineCapability } from '../engine/HttpClientEngineCapability.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IOException1wyutdmfe71nu as IOException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import {
  toString1pkumu07cwy4m as toString,
  captureStack1fzi4aczwc4hg as captureStack,
  createThis2j2avj17cvnv2 as createThis,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CopyableThrowable1mvc99jcyvivf as CopyableThrowable } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Debug.common.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  getKClass3t8tygqu4lcxf as getKClass,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ClientUpgradeContent299vg0lx1tyfp as ClientUpgradeContent } from '../request/ClientUpgradeContent.mjs';
import { isWebsocket1w1xog9vfgwm1 as isWebsocket } from '../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { SSEClientContent14bbfeddoyr65 as SSEClientContent } from './sse/SSEClientContent.mjs';
import { CoroutineName2g5zosw74tf0f as CoroutineName } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineName.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Send_instance3jwyi367vhqvc as Send_instance } from './api/CommonHooks.mjs';
import {
  Companion_getInstance4z8fvmvpott5 as Companion_getInstance,
  toDurationba1nlt78o6vu as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstancesewns20u1dyn as DurationUnit_MILLISECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { delayvyed5wvki0ic as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/Logger.web.mjs';
import { cancel1xim2hrvjmwpn as cancel } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_HttpTimeout_kt__pucqrr();
  return LOGGER;
}
var LOGGER;
function get_HttpTimeout() {
  _init_properties_HttpTimeout_kt__pucqrr();
  return HttpTimeout;
}
var HttpTimeout;
var HttpTimeoutCapabilityClass;
function HttpTimeoutCapability() {
  if (HttpTimeoutCapabilityClass === VOID) {
    class $ {
      toString() {
        return 'HttpTimeoutCapability';
      }
      hashCode() {
        return 2058496954;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HttpTimeoutCapability()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'HttpTimeoutCapability', VOID, VOID, [HttpClientEngineCapability()]);
    HttpTimeoutCapabilityClass = $;
  }
  return HttpTimeoutCapabilityClass;
}
var HttpTimeoutCapability_instance;
function HttpTimeoutCapability_getInstance() {
  return HttpTimeoutCapability_instance;
}
var HttpRequestTimeoutExceptionClass;
function HttpRequestTimeoutException() {
  if (HttpRequestTimeoutExceptionClass === VOID) {
    class $ extends IOException() {
      constructor(url, timeoutMillis, cause) {
        return new.target.v5r(url, timeoutMillis, cause);
      }
      static v5r(url, timeoutMillis, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.m4i('Request timeout has expired [url=' + url + ', request_timeout=' + toString(timeoutMillis == null ? 'unknown' : timeoutMillis) + ' ms]', cause);
        captureStack($this, $this.u5r_1);
        $this.s5r_1 = url;
        $this.t5r_1 = timeoutMillis;
        return $this;
      }
      static w5r(request) {
        var tmp = request.a5i_1.y56();
        var tmp0_safe_receiver = request.x5r(HttpTimeoutCapability_instance);
        return this.v5r(tmp, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b5s());
      }
      m13() {
        return HttpRequestTimeoutException().v5r(this.s5r_1, this.t5r_1, this.cause);
      }
    }
    initMetadataForClass($, 'HttpRequestTimeoutException', VOID, VOID, [CopyableThrowable()]);
    HttpRequestTimeoutExceptionClass = $;
  }
  return HttpRequestTimeoutExceptionClass;
}
function checkTimeoutValue($this, value) {
  // Inline function 'kotlin.require' call
  if (!(value == null || value > 0n)) {
    var message = 'Only positive timeout values are allowed, for infinite timeout use HttpTimeoutConfig.INFINITE_TIMEOUT_MS';
    throw IllegalArgumentException().o2(toString(message));
  }
  return value;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.c5s_1 = 9223372036854775807n;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        var name = 'TimeoutConfiguration';
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = getKClass(HttpTimeoutConfig());
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_1;
        try {
          tmp_1 = createKType(getKClass(HttpTimeoutConfig()), arrayOf([]), false);
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_2 = null;
          } else {
            throw $p;
          }
          tmp_1 = tmp_2;
        }
        var tmp$ret$2 = tmp_1;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$2);
        tmp.d5s_1 = new (AttributeKey())(name, tmp$ret$1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function init_io_ktor_client_plugins_HttpTimeoutConfig(_this__u8e3s4) {
  Companion_getInstance_0();
  _this__u8e3s4.y5r_1 = 0n;
  _this__u8e3s4.z5r_1 = 0n;
  _this__u8e3s4.a5s_1 = 0n;
}
var HttpTimeoutConfigClass;
function HttpTimeoutConfig() {
  if (HttpTimeoutConfigClass === VOID) {
    class $ {
      static e5s(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis) {
        Companion_getInstance_0();
        requestTimeoutMillis = requestTimeoutMillis === VOID ? null : requestTimeoutMillis;
        connectTimeoutMillis = connectTimeoutMillis === VOID ? null : connectTimeoutMillis;
        socketTimeoutMillis = socketTimeoutMillis === VOID ? null : socketTimeoutMillis;
        var $this = createThis(this);
        init_io_ktor_client_plugins_HttpTimeoutConfig($this);
        $this.f5s(requestTimeoutMillis);
        $this.g5s(connectTimeoutMillis);
        $this.h5s(socketTimeoutMillis);
        return $this;
      }
      f5s(value) {
        this.y5r_1 = checkTimeoutValue(this, value);
      }
      b5s() {
        return this.y5r_1;
      }
      g5s(value) {
        this.z5r_1 = checkTimeoutValue(this, value);
      }
      i5s() {
        return this.z5r_1;
      }
      h5s(value) {
        this.a5s_1 = checkTimeoutValue(this, value);
      }
      j5s() {
        return this.a5s_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof HttpTimeoutConfig()))
          THROW_CCE();
        if (!(this.y5r_1 == other.y5r_1))
          return false;
        if (!(this.z5r_1 == other.z5r_1))
          return false;
        if (!(this.a5s_1 == other.a5s_1))
          return false;
        return true;
      }
      hashCode() {
        var tmp0_safe_receiver = this.y5r_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getBigIntHashCode(tmp0_safe_receiver);
        var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        var tmp = imul(31, result);
        var tmp2_safe_receiver = this.z5r_1;
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : getBigIntHashCode(tmp2_safe_receiver);
        result = tmp + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
        var tmp_0 = imul(31, result);
        var tmp4_safe_receiver = this.a5s_1;
        var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : getBigIntHashCode(tmp4_safe_receiver);
        result = tmp_0 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
        return result;
      }
    }
    initMetadataForClass($, 'HttpTimeoutConfig', $.e5s);
    HttpTimeoutConfigClass = $;
  }
  return HttpTimeoutConfigClass;
}
function get_supportsRequestTimeout(_this__u8e3s4) {
  _init_properties_HttpTimeout_kt__pucqrr();
  var tmp;
  var tmp_0;
  if (!isWebsocket(_this__u8e3s4.a5i_1.o55())) {
    var tmp_1 = _this__u8e3s4.d5i_1;
    tmp_0 = !(tmp_1 instanceof ClientUpgradeContent());
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var tmp_2 = _this__u8e3s4.d5i_1;
    tmp = !(tmp_2 instanceof SSEClientContent());
  } else {
    tmp = false;
  }
  return tmp;
}
function applyRequestTimeout(_this__u8e3s4, request, requestTimeout) {
  _init_properties_HttpTimeout_kt__pucqrr();
  if (requestTimeout == null || requestTimeout === 9223372036854775807n)
    return Unit_instance;
  var executionContext = request.e5i_1;
  var tmp = new (CoroutineName())('request-timeout');
  var killer = launch(_this__u8e3s4, tmp, VOID, applyRequestTimeout$slambda(requestTimeout, request, executionContext));
  var tmp_0 = request.e5i_1;
  tmp_0.fx((it) => {
    killer.nx();
    return Unit_instance;
  });
}
function HttpTimeoutConfig$_init_$ref_dl1k0m() {
  return constructCallableReference(() => HttpTimeoutConfig().e5s(), 0, 0, 221);
}
function HttpTimeout$lambda($this$createClientPlugin) {
  _init_properties_HttpTimeout_kt__pucqrr();
  var requestTimeoutMillis = $this$createClientPlugin.u5m_1.b5s();
  var connectTimeoutMillis = $this$createClientPlugin.u5m_1.i5s();
  var socketTimeoutMillis = $this$createClientPlugin.u5m_1.j5s();
  var tmp = Send_instance;
  $this$createClientPlugin.x5m(tmp, HttpTimeout$lambda$slambda(connectTimeoutMillis, socketTimeoutMillis, requestTimeoutMillis));
  return Unit_instance;
}
function invoke$hasNotNullTimeouts(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, supportsRequestTimeout) {
  return supportsRequestTimeout && !(requestTimeoutMillis == null) || !(connectTimeoutMillis == null) || !(socketTimeoutMillis == null);
}
function HttpTimeout$lambda$slambda($connectTimeoutMillis, $socketTimeoutMillis, $requestTimeoutMillis) {
  return constructCallableReference(function *($this$on, request, $completion) {
    var supportsRequestTimeout = get_supportsRequestTimeout(request);
    var configuration = request.x5r(HttpTimeoutCapability_instance);
    var tmp;
    if (configuration == null && invoke$hasNotNullTimeouts($requestTimeoutMillis, $connectTimeoutMillis, $socketTimeoutMillis, supportsRequestTimeout)) {
      configuration = HttpTimeoutConfig().e5s();
      request.k5s(HttpTimeoutCapability_instance, configuration);
      tmp = Unit_instance;
    }
    var tmp0_safe_receiver = configuration;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.apply' call
      var tmp0_elvis_lhs = tmp0_safe_receiver.i5s();
      tmp0_safe_receiver.g5s(tmp0_elvis_lhs == null ? $connectTimeoutMillis : tmp0_elvis_lhs);
      var tmp1_elvis_lhs = tmp0_safe_receiver.j5s();
      tmp0_safe_receiver.h5s(tmp1_elvis_lhs == null ? $socketTimeoutMillis : tmp1_elvis_lhs);
      if (supportsRequestTimeout) {
        var tmp2_elvis_lhs = tmp0_safe_receiver.b5s();
        tmp0_safe_receiver.f5s(tmp2_elvis_lhs == null ? $requestTimeoutMillis : tmp2_elvis_lhs);
        applyRequestTimeout($this$on, request, tmp0_safe_receiver.b5s());
      }
    }
    return yield* $this$on.b5p(request, $completion);
  }, 2);
}
function applyRequestTimeout$slambda($requestTimeout, $request, $executionContext) {
  return constructCallableReference(function *($this$launch, $completion) {
    Companion_getInstance();
    // Inline function 'kotlin.time.Companion.milliseconds' call
    var this_0 = $requestTimeout;
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    yield* delay(tmp$ret$0, $completion);
    var cause = HttpRequestTimeoutException().w5r($request);
    // Inline function 'io.ktor.util.logging.trace' call
    var this_1 = get_LOGGER();
    if (get_isTraceEnabled(this_1)) {
      var tmp$ret$2 = 'Request timeout: ' + $request.a5i_1.toString();
      this_1.c4u(tmp$ret$2);
    }
    cancel($executionContext, ensureNotNull(cause.message), cause);
    return Unit_instance;
  }, 1);
}
var properties_initialized_HttpTimeout_kt_9oyjbd;
function _init_properties_HttpTimeout_kt__pucqrr() {
  if (!properties_initialized_HttpTimeout_kt_9oyjbd) {
    properties_initialized_HttpTimeout_kt_9oyjbd = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpTimeout');
    var tmp = HttpTimeoutConfig$_init_$ref_dl1k0m();
    HttpTimeout = createClientPlugin('HttpTimeout', tmp, HttpTimeout$lambda);
  }
}
//region block: init
HttpTimeoutCapability_instance = new (HttpTimeoutCapability())();
//endregion
//region block: exports
export {
  HttpTimeoutCapability_instance as HttpTimeoutCapability_instance26tgzga341tse,
  HttpRequestTimeoutException as HttpRequestTimeoutException19335ch7q7rkf,
  get_HttpTimeout as get_HttpTimeout3mcrbvfnvmyx2,
};
//endregion

//# sourceMappingURL=HttpTimeout.mjs.map
